import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import useFetch from "../../../../../../Resident/fetch"
import { ResourceComponent } from './components/AgendaItem'
import { resourceIsCurrent } from '../../../../utils'

function BulkReviewModal(props) {
  const resources = props.resources.filter(resource => resource.has_assignment)
  const pendingResources = resources.filter(resource => resource.status !== 'completed')
  const organization = props.organization
  const isToday = props.isToday
  const { review, bulkReviews, checkAll } = useSelector(state=>state.bulkReviews)
  const fetch = useFetch()
  const [show, setShow] = useState(props.show)
  const dispatch = useDispatch()

  const saveBulkReviewAction = () => {
    saveBulkReview()
  }

  const Checkbox = props => (
    <input type="checkbox" {...props}/>
  )

  const saveBulkReview = () => {
    return fetch(
      `/organizations/${organization.name}/agenda/bulk_review.json`,
      {
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        data: JSON.stringify({
          bulk_review: {
            bulk_review_resources: bulkReviews,
            notes: review
          },
        })
      }
    ).then(() => {
      closeModal();
      window.location.reload();
    });;
  };

  const handleChange = (review) => {
    dispatch({type:"ADD_REVIEW", payload: {review: review}});
  }

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      dispatch({type:"SELECT_ALL", payload: {}});
      pendingResources.forEach(resource => {
        dispatch({type:"ADD_RESOURCE", payload: {resource_id: resource.id, resource_type: resource.resource_type, resources_size: pendingResources.length}});
      })
    }
    else {
      unSelectAll();
    }
  }

  const unSelectAll = () => {
    dispatch({type:"UNSELECT_ALL", payload: {}});
    pendingResources.forEach(resource => {
      dispatch({type:"REMOVE_RESOURCE", payload: {resource_id: resource.id, resource_type: resource.resource_type, checkAll: false}});
    })
  }

  const closeModal = () => {
    setShow(false);
    unSelectAll();
    props.setShowBulkReviewModal(false);
  }

  return (
    <Modal
      show={show}
      onHide={() => closeModal()}
    >
      <Modal.Body className="p-4">
        {
          <div>
            {
              pendingResources.length > 0 &&
              <div className="d-flex justify-content-end">
              <p className="pr-2 m-0">Select All</p>
                <Checkbox
                  style={{ cursor: 'pointer' }}
                  onChange={event => handleSelectAll(event)}
                  checked={checkAll}
                />
              </div>
            }
            <ResourcesByStatus
              organization={organization}
              label="Pending Review"
              resources={resources.filter(resource => resource.status == 'pending_completing')}
              pendingResources={pendingResources}/>
            <ResourcesByStatus
              organization={organization}
              label="Review"
              resources={resources.filter(resource => resource.status == 'completed')}
              pendingResources={pendingResources}/>

            { isToday &&
              <ResourcesByStatus
                organization={organization}
                label="Overdue"
                resources={resources.filter(resource => resource.status == 'overdue')}
                pendingResources={pendingResources}/>
            }
            <ResourcesByStatus
              organization={organization}
              label={isToday && "Today"}
              resources={resources.filter(resource => resourceIsCurrent(resource))}
              pendingResources={pendingResources}/>
            <ResourcesByStatus
              organization={organization}
              label="Upcoming"
              resources={resources.filter(resource => resource.status == 'upcoming')}
              pendingResources={pendingResources}/>
            { pendingResources.length > 0 ?
              <Form.Group controlId="review">
                <Form.Label>Review</Form.Label>
                <Form.Control
                  value={review}
                  onChange={(e)=>handleChange(e.target.value)}
                />
              </Form.Group> : <p>No Pending Assignment</p>
            }
          </div>
        }
      </Modal.Body>
      {(
        pendingResources.length > 0 &&
        <Modal.Footer>
          <Button variant="info" onClick={() => saveBulkReviewAction()}>
            Submit
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}

function ResourcesByStatus(props){
  const { resources, label, organization } = props
  const pendingResources = resources.filter(resource => resource.status !== 'completed')
  return (
    pendingResources.length > 0 &&
    <div className="mt-2">
      <h5 className="pb-2">{label}</h5>
      {pendingResources.map((resource, index) => (
        <ResourceComponent key={index} {...resource} organization={organization} fromBulkReview={true} resources_size={pendingResources.length}/>
      ))}
    </div>

  )
}

export default BulkReviewModal;
